import './Wallet.css';
import mark_wallet from "../assets/mark_wallet.png"
import tabls from "../assets/tabls.png"
import payment from "../assets/payment.png"
import wallet from "../assets/wallet.png"

export const Wallet = () => {
    return <div className="wallet">
        <div className="wallet_left">
            <img className="left_mark" src={mark_wallet} alt="mark_wallet" draggable={false} />
            <div className="left_text_mark">
                <span className="text_text">bla bla blalalala blalalala blalabla bla blalalala blala lala blalall</span>
                <span className="text_sign">- Mark Cuban</span>
            </div>
            <img className="left_tabls" src={tabls} alt="tabls" draggable={false} />
        </div>
        <div className="wallet_right">
            <span className="right_title">BUY WITH A DEBIT CARD OR CRYPTO!</span>
            <img style={{ width: "571px", height: "43px" }} src={payment} alt="payment" draggable={false} />
            <div style={{ cursor: "no-drop" }} className="right_button">
                <span>Soon</span>
                <img src={wallet} alt="wallet" draggable={false} />
            </div>
        </div>
    </div>
}